import { LogoutOutlined } from '@ant-design/icons';

import { useAuth0 } from '@auth0/auth0-react';
import { Alert, Button, Space, Typography } from 'antd';

import { localStorageUtility } from '../../clientUtils';

const { Title, Paragraph } = Typography;

const NoRolesError = ({ email }) => {
  const { logout } = useAuth0();

  const handleLogout = () => {
    localStorageUtility.onLogout();
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: '20px',
        backgroundColor: '#f0f2f5'
      }}>
      <div style={{ maxWidth: '500px', width: '100%' }}>
        <Alert
          description={
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
              <Paragraph style={{ margin: 0, fontSize: '16px' }}>
                No roles have been assigned to your account
                {email ? ` (${email})` : ''}. Please contact your administrator.
              </Paragraph>
              <Button icon={<LogoutOutlined />} onClick={handleLogout} size="large" type="primary">
                Logout
              </Button>
            </Space>
          }
          message={
            <Title level={4} style={{ margin: 0 }}>
              Access Not Configured
            </Title>
          }
          showIcon
          style={{ padding: '24px' }}
          type="warning"
        />
      </div>
    </div>
  );
};

export default NoRolesError;
